// src/util/shared.ts
import { deprecated, deprecatedProperty } from "@clerk/shared/deprecated";
import {
  getCookieSuffix,
  getSuffixedCookieName,
  isDevelopmentFromSecretKey,
  isProductionFromSecretKey,
  parsePublishableKey
} from "@clerk/shared/keys";
import { retry } from "@clerk/shared/retry";
import { addClerkPrefix, getClerkJsMajorVersionOrTag, getScriptUrl } from "@clerk/shared/url";
import { buildErrorThrower } from "@clerk/shared/error";
import { createDevOrStagingUrlCache } from "@clerk/shared/keys";
var errorThrower = buildErrorThrower({ packageName: "@clerk/backend" });
var { isDevOrStagingUrl } = createDevOrStagingUrlCache();

export {
  errorThrower,
  deprecated,
  getCookieSuffix,
  getSuffixedCookieName,
  isDevelopmentFromSecretKey,
  parsePublishableKey,
  retry
};
//# sourceMappingURL=chunk-YBVFDYDR.mjs.map